import { useTranslations } from "use-intl";

import { Link } from "@/components/link";
import { withSiteTitle } from "@/lib/page-title";

export function NotFound() {
  const t = useTranslations("globals.notFound");

  return (
    <>
      <title>{withSiteTitle(t("title"))}</title>
      <div className="flex min-h-screen flex-col items-center justify-center bg-[#0a0a0a] px-4 text-center">
        <svg
          className="mb-8"
          width="160"
          height="160"
          viewBox="0 0 160 160"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <circle cx="80" cy="80" r="78" stroke="#262626" strokeWidth="2" fill="#171717" />
          <circle cx="80" cy="80" r="68" stroke="#1f1f1f" strokeWidth="0.5" fill="none" />
          <circle cx="80" cy="80" r="60" stroke="#1f1f1f" strokeWidth="0.5" fill="none" />
          <circle cx="80" cy="80" r="52" stroke="#1f1f1f" strokeWidth="0.5" fill="none" />
          <circle cx="80" cy="80" r="44" stroke="#1f1f1f" strokeWidth="0.5" fill="none" />
          <circle cx="80" cy="80" r="36" stroke="#1f1f1f" strokeWidth="0.5" fill="none" />
          <circle cx="80" cy="80" r="26" fill="#ee5b2b" />
          <circle cx="80" cy="80" r="4" fill="#0a0a0a" />
          <text
            x="80"
            y="86"
            textAnchor="middle"
            fill="#0a0a0a"
            fontSize="28"
            fontWeight="700"
            fontFamily="Space Grotesk, system-ui, sans-serif"
          >
            ?
          </text>
        </svg>

        <p className="mb-2 text-6xl font-bold text-white">404</p>
        <h1 className="mb-3 text-xl font-semibold text-white">{t("title")}</h1>
        <p className="mb-8 max-w-md text-base text-neutral-400">{t("message")}</p>
        <Link
          to="/"
          className="rounded-lg bg-[#ee5b2b] px-6 py-2.5 text-sm font-medium text-white transition-colors hover:bg-[#d94f24]"
        >
          {t("backHome")}
        </Link>

        <p className="mt-12 text-sm font-medium text-[#ee5b2b]">garimpa.club</p>
      </div>
    </>
  );
}
